import React, { useState, useEffect } from "react";
import { CheckCircle, XCircle, Info, AlertTriangle, X } from "lucide-react";
import "./Toast.css";

const icons = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: AlertTriangle,
};

export default function Toast({
  title,
  message,
  variant = "success",
  onClose,
}) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // No-op: auto-dismiss handled by context timer
  }, []);

  const handleClose = () => {
    setExiting(true);
    setTimeout(onClose, 280); // match CSS exit animation duration
  };

  const Icon = icons[variant] || icons.info;

  return (
    <div
      className={`toast toast--${variant} ${exiting ? "toast--exit" : ""}`}
      role="status"
    >
      <div className="toast__icon">
        <Icon size={20} />
      </div>
      <div className="toast__body">
        {title && <p className="toast__title">{title}</p>}
        <p className="toast__message">{message}</p>
      </div>
      <button
        className="wb-plain toast__close"
        onClick={handleClose}
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
}
